import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { cancelBooking } from '../state/actions/service';

import '../styles/success.scss';

function CancelBooking() {
  const loading = useSelector((state) => state.service.loading);
  const error = useSelector((state) => state.service.error);
  const success = useSelector((state) => state.service.success);
  const dispatch = useDispatch();

  const { token } = useParams();

  useEffect(() => {
    if (token) {
      dispatch(cancelBooking(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="container success-container text-center">
      {loading && (
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      )}
      {success && <div><h1>Din bokning har annullerats</h1><div>Klicka <a href="https://mioo.cc/sv/cykelverkstad/">här</a> för boka en ny tid</div></div>}
      {!success && error && <h1>Det gick inte att avbryta din bokning</h1>}
      {error && <p className="text-danger">{error}</p>}
    </div>
  );
}

export default CancelBooking;
